import { BpCardCarousel } from '../../../../shared/components/cards/carousel/BpCardCarousel'
import { SwiperSlide } from 'swiper/react'
import { BpArticle } from '../../../../shared/components/cards/article/BpArticle'
import { SimpleList } from '../../../../shared/components/cards/simple-list/SimpleList'
import { SimpleListItem } from '../../../../shared/components/cards/simple-list/simple-list-item/SimpleListItem'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { IconLink } from '../../../../shared/components/icons/IconLink'
import React from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { OrganicResultsFilterInterface } from '../../model/types/OrganicResultsFilter.interface'
import { selectOrganicResultsFilters } from '../../model/organicResultsSlice'
import { AdvertiserReportsOrganicItems } from '../../../../app/api'
import { setDetailedInfoFilter } from '../../../domain-overview/model/domainOverviewSlice'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './OrganicResultsTableExpandRow.module.scss'

export const OrganicResultsTableExpandRow = ({
  pages,
  keywords,
  affiliates,
  domain: site,
}: AdvertiserReportsOrganicItems) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { search } = useLocation()
  const dispatch = useDispatch()
  const organicResultsFilters = useAppSelector<OrganicResultsFilterInterface>(
    selectOrganicResultsFilters,
  )
  const { project, engine_id, country, dateRange } = organicResultsFilters

  const mapToArrayArrays = (arr: string[] | object, partSize = 10): string[][] => {
    const mapArr: string[] = !Array.isArray(arr) ? Object.values(arr) : arr
    const mappedArray: string[][] = []
    let i = 0
    while (i <= mapArr.length) {
      mappedArray.push([...mapArr.slice(i, i + partSize)])
      i = i + partSize
    }
    return mappedArray
  }

  const handleLinkToOverview = () => {
    navigate('/detailed-info')
    dispatch(
      setDetailedInfoFilter({
        project,
        engine_id,
        site,
        country,
        dateRange,
        keyword: undefined,
        page_url: undefined,
        has_brand: undefined,
        show_hidden: undefined,
        reversed_filters: '',
      }),
    )
  }

  return (
    <div className={clsx(styles.root)}>
      <div className={clsx(styles.carouselsRow)}>
        <BpCardCarousel className={clsx(styles.carousel)} title={t('pages.organicResults.pages')}>
          {pages.map(({ title, url }, index) => (
            <SwiperSlide key={(title ?? '') + index}>
              <div className={clsx(styles.articleWrapper)}>
                <BpArticle href={url} link={url?.split('?')[0]} title={title} />
              </div>
            </SwiperSlide>
          ))}
        </BpCardCarousel>
        <BpCardCarousel
          className={clsx(styles.carousel)}
          title={t('pages.organicResults.allKeywords')}
        >
          {mapToArrayArrays(keywords).map((arrKeywords, index) => (
            <SwiperSlide key={index}>
              <SimpleList>
                {arrKeywords.map((keyword) => (
                  <SimpleListItem key={keyword}>{keyword}</SimpleListItem>
                ))}
              </SimpleList>
            </SwiperSlide>
          ))}
        </BpCardCarousel>
        <BpCardCarousel
          className={clsx(styles.carousel)}
          title={t('pages.organicResults.allAffiliates')}
        >
          {mapToArrayArrays(affiliates).map((arrAffiliates, index) => (
            <SwiperSlide key={index}>
              <SimpleList>
                {arrAffiliates.map((affiliate) => (
                  <SimpleListItem key={affiliate}>{affiliate}</SimpleListItem>
                ))}
              </SimpleList>
            </SwiperSlide>
          ))}
        </BpCardCarousel>
      </div>
      <Link
        className={clsx(styles.link)}
        to={`/detailed-info${search}&site=${site}`}
        onClick={(e) => e.preventDefault()}
      >
        <BpButton
          className={clsx(styles.button)}
          iconLeft={<IconLink />}
          onClick={handleLinkToOverview}
        >
          {t('buttons.domainOverview')}
        </BpButton>
      </Link>
    </div>
  )
}
